

var GeneralUtils = function(){
	
	
}

GeneralUtils.convertNumberToLabeledObject = function(arg1)
{
	var loc1= (arg1 > 0) ? "+" : "";
	loc1 = loc1 + Number(arg1).toFixed(2);
	var loc2 = {"label":loc1, "data":arg1};
	return loc2;
}